import { format } from '@lingoda/dates';

export const formatTitleDate = format('cccc, d MMM yyyy');
